import { runRevenueIntelligenceChatRequest } from "../lib/revenue-intelligence-chat-request";

// Target Outlook's server budget is 20s including setup; allow response overhead.
// Other Revenue Intelligence chat callers keep their existing timeouts.
export const OUTLOOK_READOUT_TIMEOUT_MS = 25_000;

export function canRetryOutlookReadout(error: unknown) {
  const failure = error as { name?: string; code?: string; status?: number } | null;
  if (["chat_capacity_unavailable", "chat_configuration_unavailable", "access_denied", "rate_limited", "invalid_request"].includes(failure?.code ?? "")) return false;
  return failure?.name === "AbortError" || error instanceof TypeError
    || [502, 503, 504].includes(failure?.status ?? 0);
}

export async function requestOutlookReadout<T>(request: (signal: AbortSignal) => PromiseLike<T>,
  options: { timeoutMs?: number; retryDelayMs?: number } = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      return await runRevenueIntelligenceChatRequest(request, options.timeoutMs ?? OUTLOOK_READOUT_TIMEOUT_MS);
    } catch (error) {
      if (attempt === 1 || !canRetryOutlookReadout(error)) throw error;
      await new Promise(resolve => setTimeout(resolve, options.retryDelayMs ?? 1_000));
    }
  }
}
